import { EGLOBAL_LOGO } from "../constant/constant";
import { ApiResult } from "./PromiseResult";
import { FinalTransaction } from "./transactions";

export class ConsultationSuccessData {
    consultation_request_number: string = '';
    invoice_id: string = '';
    transaction_no: number = 0;
    transaction_id: string = '';
}

export class PaymentSuccessResult {
    consultationData: ConsultationSuccessData = new ConsultationSuccessData();
}

export class Item {
    name: string;
    raw_amount: number;
    rendered_amount: string;
}

export enum payment_method {
    paypal = 'paypal',
    razorpay = 'razorpay',
    stripe = 'stripe'
}
export class Basket {
    item_list: Item[] = [];
    currency_type: string = "";
    order_name: string = "";
    rendered_total: string = "";
    raw_total: number = -1;
    patient_guid: string = "";
    payment_method: payment_method = null;
    disclaimer?: string = "";
}

export class payment_gateway_id {
    razor_pay_id?: string;
}
export class order_model {
    first_name: string = "";
    middle_name: string = "";
    last_name: string = "";
    basket: Basket = new Basket();
    transaction_id: string = "";
    payment_id: string = "";
    payment_gateway_id?: payment_gateway_id = new payment_gateway_id();
}

export class RazorPayOptions {
    key: string = ""; // add razorpay key here
    name: string = 'eGlobalDoctors';
    description: string = "";
    amount: number = 0 * 100;
    order_id: string = "";
    image: string = ""; // razorpay takes amount in paisa
    prefill: {};
    notes: {};
    theme: {
        color: string;
    };
    handler: any;
    modal: any;
}
export class Payment_Data {
    is_paypal: boolean = false;
    is_razorpay: boolean = false;
    is_stripe: boolean = false;
    stripe_checkout_url: string = '';
    paypal_gateway_error_message: string = "";
    paypal_device_data: any = null;
    razorpay_key: string = "";
    // payment_id: string = "";
    payment_token: string = "";
    eglobaldoctors_logo: string = EGLOBAL_LOGO;
    // basket_data: Basket = new Basket();
    payment_start_api_result: ApiResult = new ApiResult(false);
    transaction_submit_api_result: ApiResult = new ApiResult(false);
    razorpay_options: RazorPayOptions = new RazorPayOptions();
    final_transaction_data: FinalTransaction = new FinalTransaction();
    order_data: order_model = new order_model();
    paymentSuccessData: PaymentSuccessResult = new PaymentSuccessResult();

}

